// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics } from '@trello/atlassian-analytics';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Confirm } from 'app/scripts/views/lib/Confirm';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openUnsubscribe = function (this: any, e: any) {
  const terminologyWatchExperimentVariant = featureFlagClient.getTrackedVariation(
    'teamplates.web.terminology-watch-experiment',
    'not-enrolled',
  );

  const enrolledInWatchExperiment =
    // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
    terminologyWatchExperimentVariant === 'experiment-v1' ||
    // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
    terminologyWatchExperimentVariant === 'experiment-v2';
  stopPropagationAndPreventDefault(e);

  Confirm.toggle(enrolledInWatchExperiment ? 'unfollow' : 'unwatch', {
    elem: $(e.target).closest('.js-board-header-subscribed')[0],
    model: this.model,
    confirmBtnClass: 'nch-button nch-button--danger',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fxConfirm: (e: any) => {
      if (this.model.get('subscribed') === false) {
        return;
      }
      const traceId = Analytics.startTask({
        taskName: 'edit-board/subscribed',
        source: 'boardScreen',
      });

      return this.model.subscribeWithTracing(false, {
        taskName: 'edit-board/subscribed',
        source: 'boardScreen',
        traceId,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (err: any) => {
          if (!err) {
            Analytics.sendTrackEvent({
              action: 'unsubscribed',
              actionSubject: 'board',
              source: 'boardScreen',
              containers: {
                board: {
                  id: this.model.id,
                },
              },
              attributes: {
                taskId: traceId,
              },
            });
          }
        },
      });
    },
  });
};
